import { useMemo } from 'react'

import { GenericalRecord } from '../../types/utilities'
import { parse } from '../../utils/querystring'

export const useParsedSearch = (search: string) => {
  return useMemo(
    () => parse(search, { ignoreQueryPrefix: true }),
    [search]
  ) as GenericalRecord
}
